export default (params) => ({
  trigger: {
    name: 'review_panel.thumbs_up_down',
    params: params,
  },
  config: {
    schema: {
      feedback: {
        enum: [
          'vote_up',
          'vote_down',
        ],
      },
      unique_id: {
        type: 'string',
      },
    },
    event: {
      name: 'select_feedback',
      params: {
        sub_feature: null,
        qaty_topic: null,
        id_type: 'review_id',
      },
    },
  },
});
